import Kyc from '../../components/Profile/Kyc';

const CentroVerificacion = () => <Kyc />;

export default CentroVerificacion;
